module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/245-jersey-e4ce7f2956d4f9679f3b3ce1faffcf46.svg";